/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import MuiTextarea, { TextareaProps } from '@mui/joy/Textarea'
import { grey } from '@mui/material/colors'

interface PropsType extends TextareaProps {
	className: string
}

export const Textarea = (props: PropsType) => {
	return <MuiTextarea {...props} css={style} />
}

const style = css({
	background: '#fff',

	'textarea[readonly]': {
		background: grey[50],
	},
})
